import { schema, types } from 'papr'
import { USER_DELETION_TTL } from '../shared/constants'
import { userSchema } from './user'
const collectionName = 'archivedusers'

export const archivedUserSchema = schema(
	{
		...userSchema[0],
		user: types.objectId(),
	},
	{
		timestamps: true,
	},
)

export const createArchivedUserIndex = async (db) => {
	await db.createIndex(
		collectionName,
		{
			createdAt: 1,
		},
		{
			expireAfterSeconds: USER_DELETION_TTL,
		},
	)
}

export type ArchivedUserDocument = (typeof archivedUserSchema)[0]
export type ArchivedUserDefaults = (typeof archivedUserSchema)[1]
